var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as React from "react";
import { Size, VoucherState } from "../../../services/voucher";
import MVoucherOne from "./MVoucherOne";
import MVoucherTwo from "./MVoucherTwo";
import MVoucherThree from "./MVoucherThree";
import { getImg } from "./utils";
import TipsModal from "./TipsModal";
import miniTip from "../../components/MiniTip";
import { isNotBlankArray } from "../../../utils/array";
class Voucher extends React.Component {
    constructor(props) {
        super(props);
        this.handleUpdateData = (vouchers) => {
            const { callbackData } = this.props;
            const vouchersId = vouchers.map(item => item.voucherId);
            return callbackData(vouchersId).then(result => {
                const newdata = result ? [...result] : [];
                const combined = [];
                newdata.forEach((item, index) => {
                    var _a;
                    const data = vouchers[index];
                    if (item.id === ((_a = vouchers[index]) === null || _a === void 0 ? void 0 : _a.voucherId)) {
                        Object.assign(data, Object.assign({}, item));
                    }
                    combined.push(data);
                });
                this.setState({ vouchers: (newdata === null || newdata === void 0 ? void 0 : newdata.length) > 0 ? [...combined] : [...vouchers] });
            });
        };
        this.closeModal = () => {
            this.setState({ isShow: false });
        };
        this.showModal = () => {
            this.setState({ isShow: true });
        };
        this.handleClick = (data) => {
            return this.props.callbackData([data.voucherId]).then((result => {
                const voucherData = result && result[0];
                const currentData = Object.assign({}, data, Object.assign({}, voucherData));
                this.setState({ chooseData: currentData });
                this.claimDown(currentData);
            }));
        };
        this.claimDown = (data) => __awaiter(this, void 0, void 0, function* () {
            const { clickJump } = this.props;
            const { remainCount, voucherState, link } = data;
            switch (voucherState) {
                case VoucherState.canReceive:
                    miniTip("Voucher coming soon", 800);
                    break;
                case VoucherState.Received:
                    this.receiveVoucher(data);
                    break;
                case VoucherState.ComingSoon:
                    miniTip("Voucher has been Fully Redeemed", 800);
                    break;
                case VoucherState.RanOut:
                    if (link) {
                        clickJump(link);
                        break;
                    }
                    if (typeof remainCount === "number" && remainCount <= 0) {
                        miniTip("Voucher has been Fully Redeemed", 800);
                        break;
                    }
                    miniTip("You have reached the voucher redemption limit", 800);
                    break;
                case VoucherState.Expired:
                    miniTip("Voucher has expired", 800);
                    break;
                default:
            }
        });
        this.receiveVoucher = (data) => __awaiter(this, void 0, void 0, function* () {
            const { callback, callbackLogin, onClickVoucherCb } = this.props;
            onClickVoucherCb && onClickVoucherCb(data);
            yield callback(data).then((resp) => {
                if (resp.code === 200) {
                    this.showModal();
                    return true;
                }
                if (resp.code === 403) {
                    if (callbackLogin) {
                        callbackLogin(location.pathname + location.search);
                    }
                    return false;
                }
                if (resp.code === 301) {
                    miniTip("You have reached the voucher redemption limit", 800);
                    return false;
                }
                if (resp.code === 302) {
                    miniTip("Voucher has been Fully Redeemed", 800);
                    return false;
                }
                if (resp.code === 305) {
                    miniTip("Voucher has expired", 800);
                    return false;
                }
                miniTip(resp.message, 800);
                return false;
            });
        });
        this.renderMVoucherCom = (nextItems, columnNum) => {
            const { clickJump, positionId, callbackText, language, baseColor } = this.props;
            const defaultProps = Object.assign(Object.assign({}, this.props), { cbJump: clickJump, vouchers: nextItems, claimDown: this.handleClick, mdId: positionId, callbackText, icons: getImg(language), baseColor });
            switch (columnNum) {
                case Size.one:
                    return React.createElement(MVoucherOne, Object.assign({}, defaultProps));
                case Size.two:
                    return React.createElement(MVoucherTwo, Object.assign({}, defaultProps));
                case Size.three:
                    return React.createElement(MVoucherThree, Object.assign({}, defaultProps));
                default:
                    return null;
            }
        };
        const { data } = this.props;
        this.state = {
            vouchers: data,
            isShow: false,
            chooseData: undefined,
        };
        this.handleUpdateData(data);
    }
    render() {
        const { columnNum, clickJump } = this.props;
        const { vouchers, chooseData, isShow } = this.state;
        if (isNotBlankArray(vouchers)) {
            return (React.createElement(React.Fragment, null,
                this.renderMVoucherCom(vouchers, columnNum),
                chooseData && React.createElement(TipsModal, { data: chooseData, isShow: isShow, closeModal: this.closeModal, cbJump: clickJump })));
        }
        return null;
    }
}
export default Voucher;
